import DayByDayPlot from './DayByDayPlot';

export default DayByDayPlot;
